import CloseIcon from "@mui/icons-material/Close";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

const MFAPopup = ({
  open,
  onClose,
  qrCodeBase64,
  secretCode,
  codeOTP,
  setCodeOTP,
  handleRegisterClick,
  mfaErrorMessage,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: 20,
          textAlign: "left",
          px: 3,
          pt: 3,
        }}
      >
        Activer la vérification en deux étapes
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "grey.600",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3 }}>
        <DialogContentText
          sx={{
            color: "primary.main",
            fontSize: 14,
            lineHeight: 1.4,
            mb: 3,
          }}
        >
          Après avoir utilisé un mot de passe, confirmez votre identité à l'aide
          d'un code de vérification généré par une application
          d'authentification ou envoyé par mail.
        </DialogContentText>

        <Box
          sx={{
            backgroundColor: "#fff",
            boxShadow: 3,
            borderRadius: 2,
            p: 3,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            <PhoneIphoneIcon
              sx={{ color: "primary.main", mr: 1, fontSize: 20 }}
            />
            <Typography variant="subtitle2" fontWeight="medium">
              Code de l'authentification
            </Typography>
          </Box>

          <Divider sx={{ borderBottomWidth: 2, mb: 3 }} />

          <Box mb={2}>
            <Typography fontSize={14} color="text.secondary">
              Vous devez configurer Mobile Authenticator pour activer votre
              compte. Installez l'application suivante sur votre mobile :
            </Typography>
            <Typography
              fontSize={14}
              fontWeight="bold"
              color="text.primary"
              mt={1}
            >
              - Portnet ID
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 250 }}>
              <Typography fontSize={14} mb={2}>
                Ouvrez l'application et scannez le QR-code
              </Typography>
              <Box
                component="img"
                src={`data:image/png;base64,${qrCodeBase64}`}
                alt="QR Code"
                sx={{ width: 200, height: 200 }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 50,
                fontWeight: "bold",
                fontSize: 18,
              }}
            >
              OU
            </Box>

            <Box sx={{ flex: 1, minWidth: 250 }}>
              <Typography fontSize={14} mb={1}>
                Saisir le code suivant :
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  borderRadius: 1,
                  p: 2,
                  fontFamily: "monospace",
                  fontSize: 16,
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                {secretCode}
              </Box>
            </Box>
          </Box>
        </Box>

        <Typography fontSize={14} mb={1}>
          Saisissez le code à 6 chiffres fourni par l'application et cliquez sur
          Envoyer pour terminer la configuration.
        </Typography>

        {mfaErrorMessage && (
          <Alert sx={{ mb: 2 }} severity="error">
            {mfaErrorMessage}
          </Alert>
        )}

        <TextField
          placeholder="Enter one-time code"
          value={codeOTP}
          labelSize={14}
          onChange={(e) => setCodeOTP(e.target.value)}
          fullWidth
          sx={{mb:2}}        
        />
        <Button
          variant="contained"
          onClick={handleRegisterClick}
          fullWidth
        >
          Enregister
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default MFAPopup;